import { Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { DataService } from '../../shared/services/data.service';
import { ResponseModel } from '../../shared/models/response-model.model';
import {
  CloseSupportTicketRequest,
  GetAllSupportTicketsRequest,
  GetSupportTicketByIdRequest,
  ReplySupportTicketRequest
} from './support-tickets.model';

@Injectable({
  providedIn: 'root'
})
export class SupportTicketsService {
  constructor(private service: DataService) {}

  getAll(data: GetAllSupportTicketsRequest) {
    const url = `api/App/SupportTicket/getAll`;
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => response)
    );
  }

  getById(data: GetSupportTicketByIdRequest) {
    const url = `api/App/SupportTicket/getById`;
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => response)
    );
  }

  reply(data: ReplySupportTicketRequest) {
    const url = `api/App/SupportTicket/reply`;
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => response)
    );
  }

  close(data: CloseSupportTicketRequest) {
    const url = `api/App/SupportTicket/close`;
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => response)
    );
  }
}
